module.exports = __webpack_public_path__ + "img/CYP.2502836b.svg";